"use client";

import { useTranslations } from "next-intl";
import S from "./index.module.scss";
import { ButtonLink } from "@/components/ui/button";
import { useDetailNewsData } from "../../hooks/useDetailNewsData";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import { Container } from "@/components/ui/container";
import { useMedia } from "@/hooks/system/useMedia";
import Picture from "@/components/ui/picture";

dayjs.locale("ru");

const Content = () => {
  const { isClient } = useMedia();
  const t = useTranslations("news");
  const { detailNews } = useDetailNewsData();

  if (!detailNews) return null;

  return (
    <div className={S.wrapper}>
      <div className={S.header}>
        <div className={S.headerText}>
          <ButtonLink href="/news" reverse arrow>
            {t("back")}
          </ButtonLink>
          <h1 className={S.title}>{detailNews?.title}</h1>
          <p className={S.date}>{dayjs(detailNews?.date).format("DD MMMM YYYY")}</p>
        </div>
        <Picture alt={detailNews?.title} image={detailNews.detail_image} />
      </div>
      {isClient && detailNews?.text && (
        <Container>
          <div className={S.description} dangerouslySetInnerHTML={{ __html: detailNews?.text }} />
        </Container>
      )}
    </div>
  );
};

export default Content;
